import React, { useMemo } from 'react';
import _ from 'lodash';
import Badge, { BadgeEnum } from '../badge/Badge';
import { MockService } from 'types/rest/mockServiceTypes';
import { resolveBadges } from 'store/mockServices/mockServiceList/mockServiceListActions';

interface BadgesProps {
  mockService: MockService;
}

const Badges = (props: BadgesProps) => {
  // Use memoized value
  const badges: BadgeEnum[] = useMemo(() => resolveBadges(props.mockService), [
    props.mockService.metadata,
    props.mockService.noMatchingRequestPreference,
    props.mockService.responseDelay,
    props.mockService.jvmMemoryOverrideEnabled,
    props.mockService.harborId,
    props.mockService.shipId,
  ]);

  return (
    <>
      {_.sortBy(badges).map((badge: BadgeEnum, index: number) => {
        return <Badge variant={badge} isMinified={badges.length >= 3} key={'badge-' + index}></Badge>;
      })}
    </>
  );
};

export default Badges;
